import React from 'react'

export const IconTeams2 = (props={}) => {
	const { size=20, imgSize=20 } = props
	return <>
		<svg width={`${size}px`} height={`${size}px`} viewBox={`0 0 ${imgSize} ${imgSize}`} stroke="currentColor" fill="currentColor" strokeWidth="0" xmlns="http://www.w3.org/2000/svg">
			<path d="M10 1.33972L2.5 5.66981V14.3302L10 18.6602L17.5 14.3302V5.66981L10 1.33972ZM16.2342 6.38239L13.6857 7.85364L7.45108 4.25472L10 2.78331L16.2342 6.38239ZM10 9.98166L3.76592 6.38239L6.20117 4.97639L12.4358 8.575L10 9.98166ZM3.75 7.81664L9.375 11.0642V16.8559L3.75 13.6083V7.81664ZM16.25 13.6083L10.625 16.8559V11.0642L16.25 7.81664V13.6083Z" />
		</svg>
	</>
}
